import type { VoteEntity } from "@/appInterface/windows/VoteWindow/VoteResults/types";

export const getVoteStats = (
    voteInfo: VoteEntity,
    myUserToken: string,
): { myVoteCount: number; totalCandidates: number } => {
    let myVoteCount = 0;

    for (const child of Object.values(voteInfo.children)) {
        child.votes.forEach((vote) => {
            if (vote.token === myUserToken) {
                myVoteCount += 1;
            }
        });
    }

    const totalCandidates = Object.keys(voteInfo.children).length;

    return { myVoteCount, totalCandidates };
};

export const getFinishEventData = (UID: string) => {
    return [
        {
            type: "property",
            UID: UID,
            fixType: "status",
            state: {
                isResolved: true,
            },
        },
    ];
};

export const getAddDurationEventData = (UID: string, duration: number) => {
    return [
        {
            type: "property",
            UID: UID,
            fixType: "status",
            state: {
                additionalDuration: duration,
            },
        },
    ];
};

export const getAddOrRemoveVoteEventData = (
    UID: string,
    widgetUID: string,
    action: string,
    userToken: string,
    accountName: string,
) => {
    const data = {
        type: "propertyBuild",
        UID,
        fixType: "votes",
        action,
        property: {
            childUID: widgetUID,
            token: userToken,
        } as { childUID: string; token: string; accountName?: string },
    };

    if (action === "add") {
        data.property.accountName = accountName;
    }
    return [data];
};
